import { Box, Flex } from "@chakra-ui/react";
import React, { Fragment, useEffect } from "react";
import GameSelector from "../../components/GameComponents/GameSelector/GameSelector";
import { useSelector } from "react-redux";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import PlatformSelector from "../../components/GameComponents/PlatformSelector/PlatformSelector";
import useCheckLogin from "../../hook/useCheckLogin";
import GameTypeSelector from "../../components/GameComponents/GameTypeSelector/GameTypeSelector";
import PlatformSelectorRight from "../../components/GameComponents/PlatformSelector/PlatformSelectorRight";
import useLongMachineSetting from "../../hook/useLongMachineSetting";
import useDeviceType from "../../hook/useDeviceType";

const GamePlatformPage = () => {
  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const { gameType, topGameList, newGameList } = isHandleAllGame;

  const { gameMainType } = useParams();

  const isMobile = useDeviceType() === "Mobile";

  const { longMachineStickyTopConfig } = useLongMachineSetting();
  // const navigate = useNavigate();

  // useEffect(() => {
  //   if (gameMainType) {
  //     const current_type = routeMapping(gameMainType)?.origin;
  //     if (!gameType?.includes(current_type)) {
  //       return navigate("/slots");
  //     }
  //   }
  // }, [gameType, gameMainType]);
  return (
    <Fragment>
      <Box
        as="section"
        px="common-y"
        pb={{
          md: "home-space",
        }}
        display={{ base: "block", xl: "none" }}
        position="sticky"
        top={longMachineStickyTopConfig}
        bgColor="rgba(0,0,0,0.5)"
        zIndex={10}
      >
        <GameTypeSelector />
        <Box
          display={{
            base: "block",
            md: "none",
          }}
        >
          <PlatformSelector />
        </Box>
      </Box>

      <Box
        // overflowY="scroll"
        flex={1}
        id="scrollableDiv"
        h="100%"
        // py={{
        //   md: "home-space",
        //   base: "0",
        // }}
        // h={{
        //   base: "80vh",
        //   md: "auto",
        // }}
        display={{ base: "block", md: "flex" }}
      >
        <Box
          py="home-space"
          px="common-y"
          mb={{
            base: "60px",
            sm: "0px",
          }}
          w={{
            base: "100%",
            md: "calc(100% - 150px)",
          }}
          mt={{ base: "0px", xl: "50px" }}
        >
          <GameSelector hiddenTitle={!isMobile} />
        </Box>
        <Box
          display={{
            base: "none",
            md: "block",
          }}
          position="relative"
          zIndex={1000}
        >
          <PlatformSelectorRight />
        </Box>
      </Box>
    </Fragment>
  );
};

export default GamePlatformPage;
